import { IObjekt } from '../models/ApiTypes';

/** Komponente für Zugriff auf Objekte als Kalibriergegenstände */
export default class KalibrierGegenstand {
  objekt: IObjekt | undefined = undefined;

  constructor(objekt: IObjekt | undefined) {
    this.objekt = objekt;
  }

  public meta(bezeichnung: string) {
    if (!this.objekt) { return; }
    if (this.objekt && this.objekt.meta) {
      let metaDatum = this.objekt.meta.find(meta => meta.bezeichnung === bezeichnung);
      return metaDatum && metaDatum.inhalt;
    }
    return undefined;
  }

  public metaAsNumber(bezeichnung: string) {
    if (!this.objekt) { return; }
    if (this.objekt && this.objekt.meta) {
      let metaDatum = this.objekt.meta.find(meta => meta.bezeichnung === bezeichnung);
      if (metaDatum) {
        return parseFloat(metaDatum.inhalt);
      }
    }
    return undefined;
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/KalibrierGegenstand.ts